import { createContext, ReactNode, useContext, useEffect } from 'react';
import { JWTContextType } from '../types';
import { useAuthFunctions, useAuth } from '../hook';
import { tokenKeyName } from '../constants';

export const AuthContext = createContext<JWTContextType | null>(null);
const AuthProvider = ({ children, baseUrl }: { children: ReactNode; baseUrl: string }) => {
  const {
    state,
    login,
    logout,
    signUp,
    resetPassword,
    initializeAuthentication,
    verifyToken,
    invalidateSession,
    initialize,
  } = useAuthFunctions(baseUrl);

  useEffect(() => {
    const accessToken = localStorage.getItem(tokenKeyName) || undefined;
    initialize(accessToken);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        method: 'jwt',
        login,
        logout,
        signUp,
        resetPassword,
        initializeAuthentication,
        verifyToken,
        invalidateSession,
        initialize,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const useAuthContext = () => useContext(AuthContext);
export { AuthProvider, useAuth, useAuthContext };
